<ncp-table #medication [(options)]="options"></ncp-table>
